import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ItemHelpLink = ({
  helpData
}) => /*#__PURE__*/_jsx(Link, {
  external: true,
  href: helpData.link,
  children: helpData.text
});
export const HelpContent = ({
  helpData
}) => {
  if (helpData) {
    return /*#__PURE__*/_jsx(ItemHelpLink, {
      helpData: helpData
    });
  }
  return null;
};
export const TextStepHelpContent = ({
  description,
  helpData
}) => {
  const helpLink = /*#__PURE__*/_jsx(HelpContent, {
    helpData: helpData
  });
  const hasHelpLink = helpData;
  if (description && hasHelpLink) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        children: description
      }), helpLink]
    });
  }
  if (description) {
    return /*#__PURE__*/_jsx(Text, {
      children: description
    });
  }
  return helpLink;
};